import { render, staticRenderFns } from "./StokBarang.vue?vue&type=template&id=ec778ab8&scoped=true&"
import script from "./StokBarang.vue?vue&type=script&lang=js&"
export * from "./StokBarang.vue?vue&type=script&lang=js&"
import style0 from "./StokBarang.vue?vue&type=style&index=0&id=ec778ab8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec778ab8",
  null
  
)

export default component.exports